import { fetchDesignSettings, applyDesignSettings } from '@/services/settingsService'

// Fire-and-forget initialization of branding from backend settings
export async function initBranding(): Promise<void> {
  try {
    const design = await fetchDesignSettings()
    applyDesignSettings(design)
  } catch {
    // Do not block app on failure
  }
}

// Auto-run when imported
initBranding()

